import type { Error } from './models/Error';

// TODO: Mover a su archivo correspondiente después de reestructurar el proyecto o migrar a utils.ts

export const isObject = (object: unknown): object is Record<string, unknown> =>
    typeof object === 'object' && object !== null;

// TODO: Mover a su archivo correspondiente después de reestructurar el proyecto o migrar a utils.ts

export const isErrorResponse = (error: unknown): error is Error =>
    isObject(error) &&
    isObject(error.error) &&
    typeof error.error.msg === 'string';

export type SocketMessage = {
    access?: {
        type: string;
        booking?: {
            field?: {
                name: string;
            };
            ini: string;
            end: string;
        };
        group?: {
            name: string;
        };
        activity?: {
            name: string;
            ini: string;
            end: string;
        };
        bono?: {
            name: string;
            consumed: number;
            amount: number;
        };
    };
    mship?: {
        id: string | number;
        fullName?: string;
        img?: {
            url: string;
        };
    };
    device?: {
        name?: string;
    };
};

export const toLowerCase = <T extends string>(x: T) =>
    x.toLowerCase() as Lowercase<T>;
